import * as DTOS from "../FeralScan.dtos";


export type SurveyAction = {
    type: string,

    //changeEventTypeRequest getEventQuestionsRequest
    eventTypeId?: number,

    //uploadFilesSuccess
    fileNames?: string,

    //uploadFilesRequest
    files?: File[],

    //uploadFilesSuccess
    guid?: string,

    //saveEventSuccess
    plotEvent?: DTOS.PlotEvent,

    //setQuestionValueRequest uploadFilesRequest
    questionIndex?: number,

    //changeSpeciesRequest getEventQuestionsRequest
    speciesId?: number,

    //getEventQuestionsSuccess saveEventRequest
    survey?: DTOS.Survey,

    //setQuestionValueRequest
    value?: string,

    uploadedFile?: DTOS.FileRecord
}

export const
    CHANGE_EVENT_TYPE_REQUEST = "CHANGE_EVENT_TYPE_REQUEST",
    CHANGE_SPECIES_REQUEST = "CHANGE_SPECIES_REQUEST",
    CLEAR_SURVEY = "CLEAR_SURVEY",
    GET_EVENT_QUESTIONS_REQUEST = "GET_EVENT_QUESTIONS_REQUEST",
    GET_EVENT_QUESTIONS_SUCCESS = "GET_EVENT_QUESTIONS_SUCCESS",
    SAVE_EVENT_REQUEST = "SAVE_EVENT_REQUEST",
    SAVE_EVENT_SUCCESS = "SAVE_EVENT_SUCCESS",
    SAVE_EVENT_FAILURE = "SAVE_EVENT_FAILURE",
    SET_QUESTION_VALUE_REQUEST = "SET_QUESTION_VALUE_REQUEST",
    UPLOAD_FILES_REQUEST = "UPLOAD_FILES_REQUEST",
    UPLOAD_FILES_SUCCESS = "UPLOAD_FILES_SUCCESS";

export function changeEventTypeRequest(eventTypeId: number): SurveyAction {
    return {
        type: CHANGE_EVENT_TYPE_REQUEST,
        eventTypeId
    };
}

export function changeSpeciesRequest(speciesId: number): SurveyAction {
    return {
        type: CHANGE_SPECIES_REQUEST,
        speciesId
    };
}

export function clearSurveyRequest(): SurveyAction {
    return {
        type: CLEAR_SURVEY
    };
}
export function getEventQuestionsRequest(speciesId: number, eventTypeId: number): SurveyAction {
    return {
        type: GET_EVENT_QUESTIONS_REQUEST,
        speciesId,
        eventTypeId
    };
}
export function getEventQuestionsSuccess(response: DTOS.SurveyResponse): SurveyAction {
    return {
        type: GET_EVENT_QUESTIONS_SUCCESS,
        survey: response.survey
    };
}

export function saveEventRequest(survey: DTOS.Survey): SurveyAction {
    return {
        type: SAVE_EVENT_REQUEST,
        survey
    };
}

export function saveEventSuccess(response): SurveyAction {
    return {
        type: SAVE_EVENT_SUCCESS,
        plotEvent: response.plotEvent
    };
}

export function saveEventFailure(): SurveyAction {
    return {
        type: SAVE_EVENT_FAILURE
    };
}

export function setQuestionValueRequest(questionIndex: number, value: string): SurveyAction {
    return {
        type: SET_QUESTION_VALUE_REQUEST,
        questionIndex,
        value
    }
}

export function uploadFilesRequest(questionIndex: number, files: File[]): SurveyAction {
    return {
        type: UPLOAD_FILES_REQUEST,
        files,
        questionIndex
    }
}

export function uploadFilesSuccess(questionIndex: number, uploadedFile: DTOS.FileRecord): SurveyAction {
    return {
        type: UPLOAD_FILES_SUCCESS,
        uploadedFile,
        questionIndex
    }
}